var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightCognitiveLoadPrinciple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 41,
    viewBox: "0 0 83 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.764648,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 20.7646C43 9.71895 51.9543 0.764648 63 0.764648C74.0457 0.764648 83 9.71895 83 20.7646C83 31.8103 74.0457 40.7646 63 40.7646C51.9543 40.7646 43 31.8103 43 20.7646Z",
    fill: "white",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCognitiveLoadPrinciple);
export default __webpack_public_path__ + "static/media/light-cognitive-load-principle.682ecd14241ee723353b03f447506e93.svg";
export { ForwardRef as ReactComponent };